import axios from "axios";
import config from "../assets/json/texts.json";

const { STATIC_URL_DEV, STATIC_URL_PROD } = config;

const api = axios.create({
  baseURL: window.location.href.includes("localhost") || window.location.href.includes("10.5") ? STATIC_URL_DEV : STATIC_URL_PROD,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.authorization = token;
    }
    // Log temporário para debug: mostra método, URL e payload enviado
    try {
      // Não quebrar caso config.data seja circular
      const safeData = typeof config.data === 'object' ? JSON.parse(JSON.stringify(config.data)) : config.data;
      console.debug(`[API Request] ${config.method?.toUpperCase() || 'METHOD'} ${config.url}`, safeData);
    } catch (err) {
      console.debug(`[API Request] ${config.method?.toUpperCase() || 'METHOD'} ${config.url} - (unable to stringify data)`);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;
